import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  showArrow?: boolean;
  href?: string;
  onLinkClick?: () => void;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  showArrow = true,
  className = '',
  href,
  onLinkClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold transition-all duration-300 transform rounded-lg hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-brand-gold text-white hover:bg-yellow-500 shadow-gold focus:ring-brand-gold',
    secondary: 'bg-brand-teal text-white hover:bg-brand-dark shadow-teal focus:ring-brand-teal'
  };
  const width = fullWidth ? 'w-full' : '';
  const content = <span className="flex items-center text-center" data-id="element-1">
      {children}
      {showArrow && <ArrowRight className="w-5 h-5 ml-2 animate-pulse" data-id="element-2" />}
    </span>;
  if (href) {
    return <a href={href} onClick={onLinkClick} className={`${baseStyles} ${variants[variant]} ${width} ${className}`} data-id="element-3">
        {content}
      </a>;
  }
  return <button className={`${baseStyles} ${variants[variant]} ${width} ${className}`} {...props} data-id="element-4">
      {content}
    </button>;
}